import { CommonModule } from "@angular/common";
import { Component, EventEmitter, input, Output } from "@angular/core";
import { NgbPopover, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { Constants } from "../../../constants/constants";
import { DashboardProjectModel } from "../../../models";
import { PictureComponent, ProgressIndicatorComponent } from "../../general";

@Component({
  selector: "adaa-tp-bars",
  imports: [
    CommonModule,
    TranslatePipe,
    NgbPopoverModule,
    TranslateTokenPipe,
    ProgressIndicatorComponent,
    PictureComponent,
  ],
  templateUrl: "./tp-bars.html",
  styleUrl: "./tp-bars.scss",
})
export class TpBarsComponent {
  projects = input.required<DashboardProjectModel[]>();
  showTargets = input<boolean>(true);
  @Output() barClicked = new EventEmitter<DashboardProjectModel>();

  constants = Constants;
  tooltipIndex: number = 0;

  public onBarHover(popover: NgbPopover, project: DashboardProjectModel) {
    this.tooltipIndex = project.id;

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ project });
    }
  }

  public onBarLeave(popover: NgbPopover) {
    this.tooltipIndex = 0;
    if (popover.isOpen()) {
      popover.close();
    }
  }
}
